import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import Meta from "../common/Meta";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import {
  archiveCafeOptionGroup,
  getCafeOptionGroups,
  getOptionGroup,
  removeCafeGroupMember,
  saveCafeGroupMember,
  saveCafeOptionGroup,
  saveCafeOptionItem,
} from "../common/api/WebApi";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import Card from "@mui/material/Card";
import MDButton from "../../components/MDButton";
import {useNavigate, useParams} from "react-router-dom";
import Icon from "@mui/material/Icon";
import NotificationItem from "../Items/NotificationItem";
import Menu from "@mui/material/Menu";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import Grid from "@mui/material/Grid";
import MDInput from "../../components/MDInput";
import {Col, Row} from "react-bootstrap";
import {useForm} from "react-hook-form";
import {formatCurrency, handleDefaultValues} from "../common/Utils";
import Confirm from "../common/Confirm";
import ManageCafeOptionItemForm from "../form/ManageCafeOptionItemForm";
import {NativeSelect} from "@mui/material";
import {getInventoryTypes} from "../common/api/InventoryApi";
import ManageCafeOptionItemFormModal from "../form/ManageCafeOptionItemFormModal";

export default function CafeOptions(props) {

  const navigate = useNavigate();

  const [context, setContext] = useContext(AppContext);

  let {guid} = useParams();

  useEffect(() => {
    if (guid) {
      getOptionGroup(guid).then((resp) => {
        startManageGroup(resp);
      })
    }
    setNewGroup(!!!guid?.length > 0)
  }, [guid]);

  const [newGroup, setNewGroup] = useState(false);

  const [saving, setSaving] = useState(false);
  const [groups, setGroups] = useState();
  const [questions, setQuestions] = useState();
  const [optionItems, setOptionItems] = useState();

  const [filter, setFilter] = useState('');

  const saveCafeGroupMemberFn = (group, item) => {
    saveCafeGroupMember(group, item).then((resp) => {
      let _groupOptionItems = [...groupOptionItems];
      _groupOptionItems.push(item);
      setGroupOptionItems(_groupOptionItems);
    })
  }

  const getOptionGroupsFn = async () => {
    getCafeOptionGroups().then((resp) => {
      setGroups([...resp]);
      setRenderIndex(renderIndex + 1)
    });
  }

  const saveGroup = async (formData) => {

    setSaving(true);

    let _formData = {...formData};
    _formData.options = [...groupOptionItems];

    saveCafeOptionGroup(_formData).then((resp) => {
      let _context = {...context};
      _context.reloadCart = true;
      _context.toast = {
        message: 'Group Saved',
        type: 'success'
      }
      setContext({..._context});
      getOptionGroupsFn();
      navigate('/cafe/cafe-groups/' + resp?.optionGroupGuid);

      setGroup({...resp})
      setSaving(false);
    });
  }

  const saveOption = async (opt) => {

    opt.sortOrder = (!group?.options?.length) ? 1 : group.options.reduce((a, b) =>
      a.sortOrder > b.sortOrder ? a : b
    ).sortOrder + 1;

    return await saveCafeOptionItem(group.optionGroupGuid, opt).then(() => {
      getOptionGroupsFn();
      getOptionGroup(group.optionGroupGuid).then((resp) => {
        startManageGroup(resp);
      })

      setSaving(false);
      setManageOptionItem(false);

    });
  }

  useEffect(() => {
    getOptionGroupsFn();
    loadInventoryTypes();
  }, []);

  const [group, setGroup] = useState(null);
  const [manageGroup, setManageGroup] = useState(false);

  const [inventoryType, setInventoryType] = useState();
  const [inventoryTypes, setInventoryTypes] = useState();

  const loadInventoryTypes = () => {
    getInventoryTypes(true).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryTypes(result);
      }
    });
  }

  const [showAddOption, setShowAddOption] = useState(false);

  const [question, setQuestion] = useState(null);
  const [optionItem, setOptionItem] = useState(null);
  const [manageQuestion, setManageQuestion] = useState(false);
  const [manageOptionItem, setManageOptionItem] = useState(false);
  const [newOptionItem, setNewOptionItem] = useState(false);

  const [renderIndex, setRenderIndex] = useState(1);
  const [groupOptionItems, setGroupOptionItems] = useState([]);

  const addQuestion = (item) => {
    let _groupOptionItems = [...groupOptionItems];
    item.sortOrder = groupOptionItems?.length || 0;
    let _count = _groupOptionItems.filter(x => x.optionGk === item.optionGk).length;
    if (_count === 0) {
      _groupOptionItems.push(item);
    }
    setGroupOptionItems(_groupOptionItems);
  }

  const addOption = (item) => {
    let _groupOptionItems = [...groupOptionItems];
    item.sortOrder = 1;
    if (_groupOptionItems?.length > 0) {
      item.sortOrder = _groupOptionItems.reduce((max, item) => item.sortOrder > max ? item.sortOrder : max).sortOrder + 1;
    }
    let _count = _groupOptionItems.filter(x => x.optionGk === item.optionGk).length;
    if (_count === 0) {
      saveCafeGroupMemberFn(group, item);
    }
  }

  const optionAttributes = (option) => {
    if (option.specialInstructions) {
      return 'Special Instructions';
    } else if (option.scheduleDate) {
      return 'Schedule';
    } else {
      if (option?.price > 0) {
        return formatCurrency(option?.price);
      } else {
        return 'Included'
      }
    }
  }
  const startManageOptionItem = (item) => {
    setOptionItem(item);
    setManageOptionItem(true);
    setRenderIndex(renderIndex + 1);
  }

  const {register, handleSubmit, setValue, reset, control} = useForm({
    values: handleDefaultValues(group)
  });

  const startNewGroup = () => {
    let x = {
      optionGroupName: '',
      optionGroupDesc: ''
    }
    setGroup({...x});
    reset({});
    reset({
      'required': false,
      'single': false,
      'specialInstructions': false
    })

    setManageGroup(true);
    let _options = [];
    setGroupOptionItems(_options);
  }

  const startManageGroup = (group) => {
    if (group?.optionGroupGuid) {
      navigate('/cafe/cafe-groups/' + group?.optionGroupGuid);
    }

    setGroup({...group});
    setManageGroup(true);
    let _options = group?.options ? [...group?.options] : [];
    setGroupOptionItems(_options);
    setRenderIndex(renderIndex + 1);
  }

  const [confirmation, setConfirmation] = useState();
  const [confirmDeleteGroup, setConfirmDeleteGroup] = useState(false);
  const [confirmDeleteOption, setConfirmDeleteOption] = useState(false);

  const handleDeleteGroup = (group) => {
    setSaving(true);
    archiveCafeOptionGroup(group).then(() => {
      setConfirmation(null);
      setConfirmDeleteGroup(false);
      if (group?.optionGroupGuid === guid) {
        navigate('/cafe/cafe-groups');
      }
      getOptionGroupsFn();
      setSaving(false);
      startNewGroup();
    });
  }


  const startArchiveGroup = (group) => {
    let confirmation = {
      title: 'Delete Cafe Group?',
      message: 'Delete ' + group.optionGroupName + '?',
      entity: group
    }
    setConfirmation(confirmation);
    setConfirmDeleteGroup(true);
  }

  const FormActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'cafe-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                startManageGroup(item)
              }} icon={<Icon>person</Icon>} title="Manage"/>

            <NotificationItem
              onClick={(e) => {
                popupState.close();
                startArchiveGroup(item)
              }} icon={<Icon>delete</Icon>} title="Delete"/>

          </Menu>
        </>
      )}
    </PopupState>);
  }

  const removeGroupMember = async (item, idx) => {
    let _groupOptionItems = [...groupOptionItems];
    removeCafeGroupMember(group, item).then((resp) => {
      let kk;
      for (let k in _groupOptionItems) {
        if (_groupOptionItems[k].optionGk === item.optionGk) {
          kk = k;
        }
      }
      _groupOptionItems.splice(kk, 1);
      setGroupOptionItems([..._groupOptionItems]);
      getOptionGroupsFn();
    });
  }

  const moveUp = (item) => {
    let _obj = [...groupOptionItems];
    let sortOrder = 2;
    for (let j in _obj) {
      _obj[j].sortOrder = sortOrder;
      sortOrder += 2;
    }
    for (let i = 0; i < _obj.length; i++) {
      if (_obj[i].optionGk === item.optionGk) {
        _obj[i].sortOrder -= 3;
      }
    }

    setGroupOptionItems([..._obj]);
    setRenderIndex(renderIndex + 1);
  }

  const moveDown = (item) => {
    let _obj = [...groupOptionItems];
    let sortOrder = 2;
    for (let j in _obj) {
      _obj[j].sortOrder = sortOrder;
      sortOrder += 2;
    }
    for (let i = 0; i < _obj.length; i++) {
      if (_obj[i].optionGk === item.optionGk) {
        _obj[i].sortOrder += 3;
      }
    }

    setGroupOptionItems([..._obj]);
    setRenderIndex(renderIndex + 1);
  }

  return (
    <DashboardLayout>

      <Meta pageTitle={'Cafe Groups'}/>

      <ContextSearchNavbar title={'Cafe Groups'}/>
      <MDBox py={3}>

        <Grid container spacing={2}>
          <Grid item sm={manageGroup ? 4 : 12} style={{
            overflow: 'auto'
          }}>

            <Card>
              <MDBox p={2}>
                <h5>
                  Groups &nbsp;
                  <MDButton
                    onClick={(e) => {
                      navigate('/cafe/cafe-groups')
                      startNewGroup()
                    }}
                    color="secondary"
                    size="small"
                    className={'pull-right'}>
                    Add New Group</MDButton>
                </h5>

                <table className="table table-striped mt-2">
                  <thead>
                  <tr>
                    <th>Name</th>
                    <th>Desc</th>
                    <th>Required</th>
                    <th>Actions</th>
                  </tr>
                  </thead>
                  <tbody>
                  {renderIndex && groups?.length === 0 && <>
                    <tr>
                      <td colSpan={4}>
                        <center>There are no cafe groups yet</center>
                      </td>
                    </tr>
                  </>
                  }
                  {renderIndex && groups?.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td><a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            startManageGroup(item)
                          }}>{item.optionGroupName}</a>
                          </td>
                          <td><a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            startManageGroup(item)
                          }}>{item.optionGroupDesc}</a>
                          </td>
                          <td>
                            {item.required && <span className={'fa fa-check'}></span>}&nbsp;
                          </td>
                          <td>
                              <span className={'pull-right'}>
                              <FormActions item={item}/>
                            </span>
                          </td>
                        </tr>
                      )
                    }
                  )}
                  {optionItems?.length === 0 && <>
                    <tr>
                      <td colSpan={2}>
                        <center>No Cafe Items</center>
                      </td>
                    </tr>
                  </>}

                  </tbody>
                </table>

              </MDBox>
            </Card>

          </Grid>

          {manageGroup && renderIndex && group && <> <Grid item sm={8} style={{
            position: 'relative',
          }}>
            <div style={{
              position: 'sticky',
              top: 120
            }}>
              <Card>
                <Row>
                  <Col xs={12}>
                    <MDBox p={2}>

                      <form onSubmit={handleSubmit(saveGroup)}>
                        <h4>{newGroup ? 'New' : 'Manage'}&nbsp;Cafe Group</h4>
                        <div><MDInput type="text" required
                                      autoComplete="off"
                                      variant="outlined"
                                      InputLabelProps={{shrink: true}}
                                      {...register('optionGroupName',
                                        {
                                          required: true
                                        })}
                                      placeholder={"Option Group Name"}
                                      className="form-control" id="optionGroupName"
                                      label="Option Group name"/>
                        </div>
                        <Row>
                          <Col sm={6}>
                            <div className="form-group mt-4">
                              <MDInput
                                variant="outlined" type="text"
                                autoComplete="off"
                                InputLabelProps={{shrink: true}}
                                {...register('optionGroupDesc')}
                                autoComplete="off"
                                className="form-control" id="optionGroupDesc"
                                label="Internal Description"
                                placeholder="Enter Internal Description"/>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="form-group" style={{
                              position: 'relative',
                              top: '-4px'
                            }}>
                              <label htmlFor={"state"} className={"native-label"}>Assign to Inventory Type</label>

                              <NativeSelect
                                autoComplete="off"
                                variant="outlined"
                                id={'inventoryType'} name={'inventoryType'} className={'form-control'}
                                {...register('inventoryType.id', {
                                  valueAsNumber: true,
                                  required: true,
                                  onChange: (e) => {
                                    setInventoryType(parseInt(e.target.value, 10))
                                  }
                                })}>
                                <option value={-1}>All</option>
                                {
                                  inventoryTypes?.map((c) =>
                                    <option value={c.id} key={c.id}>
                                      {c.name}
                                    </option>)
                                }
                              </NativeSelect>
                              
                            </div>
                          </Col>
                        </Row>

                        <div className="form-group mt-2">
                          <h6>Group options</h6>
                          <span className={'mx-2'}>
                            <label htmlFor="required">
                            <input type="checkbox"
                                   {...register('required')}
                                   id="required"/>
                              &nbsp;Required
                            </label>
                          </span>
                          <span className={'mx-2'}>
                            <label htmlFor="single">
                              <input type="checkbox"
                                     {...register('single')}
                                     id="single"/>
                              &nbsp;Single
                            </label>
                          </span>
                        </div>
                      </form>
                      {!newOptionItem && group.optionGroupGuid?.length > 0 && <MDButton
                        onClick={(e) => {
                          setOptionItem(null)
                          setNewOptionItem(true);
                        }}
                        color="secondary"
                        size="small"
                        className={'pull-right my-2'}>
                        Add Cafe Option</MDButton>}

                      {newOptionItem &&
                        <div style={{
                          display: 'block',
                          clear: 'both',
                          padding: '10px',
                          marginTop: '15px',
                          border: 'solid 1px #999'
                        }}>
                          <h6>New Item
                            <a href={"#"} className={'cursor-pointer'}
                               style={{
                                 color: "#999",
                                 float: 'right'
                               }}
                               onClick={(e) => {
                                 e.preventDefault();
                                 setNewOptionItem(false)
                               }}><span className={"fa fa-times"}></span> </a>
                          </h6>
                          <ManageCafeOptionItemForm
                            optionItem={optionItem}
                            show={manageOptionItem}
                            saving={saving}
                            handleSave={(e) => {
                              setSaving(true);
                              saveOption(e).then(() => {
                                setNewOptionItem(false);
                                const myDiv = document.getElementById('optionsTableContainer');
                                myDiv.scrollTo({
                                  top: myDiv.scrollHeight,
                                  behavior: 'smooth'
                                });
                              });
                            }}
                            handleClose={(e) => {
                              setManageOptionItem(false);
                            }}/>
                        </div>
                      }

                      {renderIndex && groupOptionItems?.length > 0 && <>
                        <div id={"optionsTableContainer"} style={{
                          border: 'solid 1px #ddd',
                          display: 'block',
                          width: '100%',
                          marginTop: '15px',
                          maxHeight: '40vh',
                          overflow: 'auto'
                        }}>

                          <table className="table">
                            <tbody>

                            {renderIndex && groupOptionItems?.sort((a, b) => a.sortOrder - b.sortOrder).map((q, index) => {
                              return (
                                <tr key={index}>

                                  <td width={"5%"}>
                                    <MDButton color="primary"
                                              disabled={index === 0}
                                              className="pull-right d-block clear clearfix mx-1"
                                              size="small"
                                              onClick={() => {
                                                moveUp(q);
                                              }}>
                                                       <span
                                                         style={{
                                                           fontSize: '16px'
                                                         }}
                                                         className={'fa fa-arrow-circle-up'}></span>
                                    </MDButton>

                                    <div style={{
                                      width: '100%',
                                      clear: 'both',
                                      height: '4px',
                                      display: 'block'
                                    }}></div>
                                    <MDButton color="primary"
                                              disabled={index === groupOptionItems.length - 1}
                                              className="pull-right d-block clear clearfix mx-1"
                                              size="small"
                                              onClick={() => {
                                                moveDown(q);
                                              }}>
                                              <span
                                                style={{
                                                  fontSize: '16px'
                                                }}
                                                className={'fa fa-arrow-circle-down'}></span>
                                    </MDButton>


                                  </td>
                                  <td>
                                    <a href="#" onClick={(e) => {
                                      e.preventDefault();
                                      startManageOptionItem(q)
                                    }}>
                                      {q.optionName}</a>
                                    <br/>
                                    <small>{optionAttributes(q)}</small>
                                  </td>

                                  <td width={"2%"}>
                                    <a href={"#"} className={'cursor-pointer'}
                                       style={{
                                         color: "#ccc"
                                       }}
                                       onClick={(e) => {
                                         e.preventDefault();
                                         removeGroupMember(q, index)
                                       }}><span className={"fa fa-times"}></span> </a>
                                  </td>
                                </tr>
                              )
                            })
                            }
                            </tbody>
                          </table>

                        </div>
                      </>
                      }

                      <MDButton
                        color="info"
                        size="small"
                        onClick={handleSubmit(saveGroup)}
                        className={'btn btn-primary my-2 pull-right'}
                      >Save
                      </MDButton>

                    </MDBox>
                  </Col>
                </Row>
              </Card>
            </div>
          </Grid>
          </>
          }
        </Grid>
      </MDBox>

      {manageOptionItem && renderIndex && <ManageCafeOptionItemFormModal
        optionItem={optionItem}
        show={manageOptionItem}
        saving={saving}
        handleSave={(e) => {
          setSaving(true);
          saveOption(e);
        }}
        handleClose={(e) => {
          setManageOptionItem(false);
        }}/>
      }

      {confirmDeleteGroup && <Confirm confirmation={confirmation}
                                      show={confirmDeleteGroup}
                                      saving={saving}
                                      handleConfirm={handleDeleteGroup}
                                      handleSave={() => {
                                        setConfirmDeleteGroup(false);
                                      }}/>}


      <Footer mt={5}/>

    </DashboardLayout>
  );
}